import * as React from "react";
import styled from "@emotion/styled";
import breakpoint from "@/utils/breakpoint";

const MiniTitle = styled.span<{
  color?: string;
  fontSize?: string;
  margin?: string;
  fontWeight?: string | number;
}>`
  font-size: ${({ fontSize = "17px" }) => fontSize};
  font-weight: ${({ fontWeight = "bold" }) => fontWeight};
  color: ${({ color = "#524939" }) => color};
  margin: ${({ margin = "0" }) => margin};
  display: inline-block;

  ${breakpoint.lessThan("sm")`
    font-size: 14px;
  `}
`;

export default React.memo(MiniTitle);
